export const receiveImports = imports => {
  return {
    type: 'RECEIVE_IMPORTS',
    imports
  }
}